module.exports = __webpack_public_path__ + "static/media/products.fd47b491.jpg";